import React, { useState, useEffect } from "react";
import { db } from "../firebase";
import { Avatar } from "@material-ui/core";
import fallbackImg from "../assets/avatar.png";

const ChatContact = ({ chat, userEmail }) => {
  const [contact, setContact] = useState({});
  const fallbackName = "Friend";

  useEffect(() => {
    const contactEmail = chat.users.filter((u) => u !== userEmail)[0];
    async function getContact(email) {
      await db
        .collection("users")
        .doc(email)
        .onSnapshot((info) => {
          setContact(info.data());
        });
    }
    getContact(contactEmail);
  }, [chat.users, userEmail]);

  const iAmSender = (chat) => {
    return chat.messages[chat.messages.length - 1].sender === userEmail;
  };

  return (
    <div className="chat-contact">
      <div className="contact-head">
        <Avatar
          alt="contact photo"
          style={{ boxShadow: "0 0 2px 1px rgb(20, 160, 160)" }}
          src={contact.photo || fallbackImg}
        />
        <div className="contact-info">
          <div className="contact-name">
            <span>{contact.name || fallbackName}</span>
            <span>
              {" "}
              {!chat.receiverHasRead && !iAmSender(chat) && (
                <i className="fa fa-bell"></i>
              )}{" "}
            </span>
          </div>
          <p className={contact.isOnline ? "status online" : "status"}>
            {" "}
            {contact.isOnline ? "online" : "offline"}{" "}
          </p>
        </div>
      </div>

      <p>
        {chat.messages[chat.messages.length - 1].message || (
          <i className="far fa-image"></i>
        )}
      </p>
    </div>
  );
};

export default ChatContact;
